module.exports = __webpack_public_path__ + "/static/sito/landing/agenti-zero-emissioni/media/infograficaDue.6471c017.pdf";